import { mapFormBasicInfoTo1091 } from 'legacy/lut/services/partner360/basicInfo/mappings/mapFormBasicInfoTo1091'
import { updatePartnerBasicInfo } from 'legacy/lut/services/partner360/basicInfo/updatePartnerBasicInfo'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { UPDATE_DEFAULT_BASIC_INFO_DATA } from '../constants'
import { isBasicInfoDefault } from '../helpers/typeGuards'
import { IFormBasicInfo } from '../models/formBasicInfo'
import { TBasicInfoDefault } from '../models/partnerBasicInfo'
import { selectDefaultBasicInfo } from '../selectors/selectDefaultBasicInfo'

export const updateDefaultBasicInfo = createAsyncThunk<
  TBasicInfoDefault | undefined,
  IFormBasicInfo
>(UPDATE_DEFAULT_BASIC_INFO_DATA, async (formData, { getState }) => {
  const state = getState()

  const { entryId, partnerId, fYear } = selectDefaultBasicInfo(state)

  if (!entryId) {
    throw new Error('unable to update defaultBasicInfo')
  }

  const mappedData = mapFormBasicInfoTo1091(formData)

  const defaultData = await updatePartnerBasicInfo({
    ...mappedData,
    EntryId: entryId,
    PartnerId: partnerId,
    FYear: fYear,
    ProgramType: null,
  })

  return isBasicInfoDefault(defaultData) ? defaultData : undefined
})
